import AuthService from "./AuthService";

//const API_URL = "http://localhost:8081/api/mail/";
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8081";
const API_URL = `${API_BASE_URL}/api/mail/`;
class EmailService {
  /**
   * Šalje PDF izveštaj pacijentu.
   * Koristi FormData jer šaljemo fajl (Blob).
   */
  sendPatientReport(pdfBlob, patientEmail, patientName) {
    const formData = new FormData();
    formData.append("file", pdfBlob, `Izvestaj_${patientName}.pdf`);
    formData.append("to", patientEmail);
    formData.append("patientName", patientName);

    // Napomena: Kada šaljemo FormData preko fetch-a, 
    // NE postavljamo "Content-Type" header ručno, 
    // jer browser mora sam da postavi boundary parametar.
    return fetch(`${API_URL}send-report`, {
      method: "POST",
      headers: {
        ...AuthService.getAuthHeader(),
        // Ovde namerno nema "Content-Type": "application/json"
      },
      body: formData,
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška pri slanju mejla: ${res.status} - ${text}`);
      }
      // Vraća tekstualni odgovor ("Email uspešno poslat!")
      return res.text();
    });
  }
}

export default new EmailService();